// client/src/api/StreamSubscriptionApi.ts
import { axiosInstance } from "../helpers/request";
import type {
  DowngradeBody,
  DowngradeMutationResult,
  BillingOperationSummary,
  PlanCheckoutBody,
  SinglePaymentRetryResult,
  StorageMutationResult,
  StreamPlan,
} from "../types/billing";

const base = (streamId: string) => `/streams/${streamId}/subscription`;

class StreamSubscriptionApi {
  cancel(streamId: string, requestKey: string) {
    return axiosInstance.delete<BillingOperationSummary>(base(streamId), {
      headers: { "Idempotency-Key": requestKey },
    });
  }
  uncancel(streamId: string, requestKey: string) {
    return axiosInstance.post<BillingOperationSummary>(`${base(streamId)}/uncancel`, undefined, {
      headers: { "Idempotency-Key": requestKey },
    });
  }
  setStorageBlocks(streamId: string, blocks: number, requestKey: string) {
    return axiosInstance.patch<StorageMutationResult>(
      `${base(streamId)}/storage`,
      { blocks },
      { headers: { "Idempotency-Key": requestKey } },
    );
  }
  upgrade(streamId: string, plan: StreamPlan, requestKey: string) {
    return axiosInstance.post<BillingOperationSummary>(`${base(streamId)}/upgrade`, { plan }, {
      headers: { "Idempotency-Key": requestKey },
    });
  }
  downgrade(streamId: string, body: DowngradeBody, requestKey: string) {
    return axiosInstance.post<DowngradeMutationResult>(
      `${base(streamId)}/downgrade`,
      body,
      { headers: { "Idempotency-Key": requestKey } },
    );
  }
  cancelDowngrade(streamId: string, requestKey: string) {
    return axiosInstance.delete<BillingOperationSummary>(`${base(streamId)}/downgrade`, {
      headers: { "Idempotency-Key": requestKey },
    });
  }
  resubscribe(streamId: string, body: PlanCheckoutBody, requestKey: string) {
    return axiosInstance.post<{ url: string | null; operationId?: string }>(
      `${base(streamId)}/resubscribe`,
      { ...body, requestKey },
    );
  }
  convert(streamId: string, body: PlanCheckoutBody, requestKey: string) {
    return axiosInstance.post<{ url: string | null; operationId?: string }>(
      `${base(streamId)}/convert`,
      { ...body, requestKey },
    );
  }
  retryPayment(streamId: string) {
    return axiosInstance.post<SinglePaymentRetryResult>(`${base(streamId)}/retry-payment`);
  }
}

const streamSubscriptionApiInstance = new StreamSubscriptionApi();
export default streamSubscriptionApiInstance;
